import { Dropdown } from '@mui/base/Dropdown';
import { Menu } from '@mui/base/Menu';
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton';
import { MenuItem as BaseMenuItem } from '@mui/base/MenuItem';
import './styles.css';
import { useEffect } from 'react';

export default function DropdownMenu({ lista, setStatus, status, border, minWidth }) {
    useEffect(() => {}, []);

    return (
        <Dropdown>
            <MenuButton>
                {status} <span style={{ color: 'white', fontSize: '14px', width: 'fit-content' }}>▼</span>
            </MenuButton>
            <Menu className="menu">
                {Array.isArray(lista) &&
                    lista.map((item, index) => (
                        <MenuItem key={index} onClick={() => setStatus(item)}>
                            {item}
                        </MenuItem>
                    ))}
            </Menu>
        </Dropdown>
    );
}

// Botão personalizado com classes CSS
const MenuButton = (props) => <BaseMenuButton {...props} className="menu-button" />;

// Itens do menu estilizados
const MenuItem = (props) => <BaseMenuItem {...props} className="menu-item" />;
